<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pv"></a>Contents</h1>
<p class="toc"><a class="xref" href="#/greenspahnEarly0007#intro">Introduction</a></p>
<p class="tocau">Frederick E. Greenspahn</p>
<p class="tocpt"><a class="xref" href="#/greenspahnEarly0008#pt01">Part I. Early Diversity</a></p>
<p class="toc"><a class="xref" href="#/greenspahnEarly0009#ch01">1. The Dead Sea Scrolls</a></p>
<p class="tocau">James VanderKam</p>
<p class="toc"><a class="xref" href="#/greenspahnEarly0010#ch02">2. Second Temple Literature outside the Canon</a></p>
<p class="tocau">Martha Himmelfarb</p>
<p class="toc"><a class="xref" href="#/greenspahnEarly0011#ch03">3. Diaspora and the “Assimilated” Jew</a></p>
<p class="tocau">Erich S. Gruen</p>
<p class="toc"><a class="xref" href="#/greenspahnEarly0012#ch04">4. Were the Ancient Jews a Nation?</a></p>
<p class="tocau">Seth Schwartz</p>
<p class="toc"><a class="xref" href="#/greenspahnEarly0013#ch05">5. How Christianity Parted from Judaism</a></p>
<p class="tocau">Adele Reinhartz</p>
<p class="tocpt"><a class="xref" href="#/greenspahnEarly0014#pt02">Part II. Emerging Normativity</a></p>
<p class="toc"><a class="xref" href="#/greenspahnEarly0015#ch06">6. The Emergence of the Synagogue</a></p>
<p class="tocau">Steven Fine</p>
<p class="toc"><a class="xref" href="#/greenspahnEarly0016#ch07">7. New Directions in Understanding Jewish Liturgy</a></p>
<p class="tocau">Ruth Langer</p>
<p class="toc"><a class="xref" href="#/greenspahnEarly0017#ch08">8. Ancient Jewish Gender</a></p>
<p class="tocau">Elizabeth Shanks Alexander</p>
<p class="toc"><a class="xref" href="#/greenspahnEarly0018#ch09">9. Inventing Rabbis</a></p>
<p class="tocau">Christine Hayes</p>
<p class="toc"><a class="xref" href="#/greenspahnEarly0019#conc">Conclusion: “In My Beginning Is My End”</a></p>
<p class="tocau">Robert Goldenberg</p>
<p class="tocbm"><a class="xref" href="#/greenspahnEarly0020#ab_contrib">About the Contributors</a></p>
<p class="tocbm"><a class="xref" href="#/greenspahnEarly0021#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// greenspahnEarly-0006.vue?29935fbe